import React, { useState, useEffect } from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { doResetPassword } from "../../../modules/auth/stores/thunk";
import "./Auth.scss";

const ResetPasswordForm = ({ token }) => {
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const { message } = useSelector((state) => state.common);
  const navigate = useNavigate();

  useEffect(() => {
    if (message) {
      navigate("/");
    }
  }, [message, navigate]);

  const handleSubmit = (params) => {
    dispatch(doResetPassword({ ...params, token }));
  };
  return (
    <div className="ResetPasswordForm">
      <Form
        scrollToFirstError
        layout="vertical"
        hideRequiredMark
        colon={false}
        onFinish={handleSubmit}
      >
        <div className="Logo">
          <Link to="/">
            <img
              src={`/logo.svg`}
              alt="logo"
            />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">Create New Password</div>
          <div className="SubTitle">
            Create a new password and login again to your account
          </div>
        </div>
        <div className="FormContent">
          <Form.Item
            label="Password"
            name="password"
            hasFeedback
            rules={[
              { required: true, message: "Required" },
              {
                validator(_, value) {
                  if (
                    !value ||
                    new RegExp(
                      "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(.{8,})$"
                    ).test(value)
                  ) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Invalid password"));
                },
              },
            ]}
          >
            <Input.Password
              size="large"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Item>
          <div className="HintPassword Invalid">
            <div className="HintTitle"> Password should be:</div>
            <Row>
              <Col span={12}>
                <div className="HintItem">
                  <img
                    src={`/icons/${
                      /.{8,}/.test(password) ? "" : "un"
                    }checked-circle.svg`}
                    alt=""
                  />{" "}
                  At least 8 characters long
                </div>
                <div className="HintItem">
                  <img
                    src={`/icons/${
                      /[a-z]/.test(password) ? "" : "un"
                    }checked-circle.svg`}
                    alt=""
                  />{" "}
                  At least one lower case
                </div>
              </Col>
              <Col span={12}>
                <div className="HintItem">
                  <img
                    src={`/icons/${
                      /\d/.test(password) ? "" : "un"
                    }checked-circle.svg`}
                    alt=""
                  />{" "}
                  At least one number
                </div>
                <div className="HintItem">
                  <img
                    src={`/icons/${
                      /[A-Z]/.test(password) ? "" : "un"
                    }checked-circle.svg`}
                    alt=""
                  />{" "}
                  At least one upper case
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            Update Password
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ResetPasswordForm;
